import styled from '@emotion/styled';

import { FONT, SPACING, COLORS } from '@zola/zola-ui/src/styles/emotion';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

export const StyledBtn = styled(ButtonV3)`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALL)}
  align-items: center;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: ${COLORS.EMPEROR};
  display: inline-flex;
  flex-flow: row;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: 0;
  padding: 0;
  text-transform: none;

  &:hover {
    background-color: transparent;
    color: ${COLORS.EMPEROR};
  }

  span {
    display: inline-block;
    padding-left: ${SPACING.XS};
  }
`;
